import React, { useState } from "react";
import "../../_css/ReportExport.css";
import ExportClass from "./ExportClass";
import ExportStudent from "./ExportStudent";

const ReportExportUI = () => {
  const [selectedTog, setselectedTog] = useState("class");
  return (
    <div className="tm-main">
      <div className="class-toggle-con" style={{ width: "fit-content" }}>
        <div
          onClick={() => setselectedTog("class")}
          className="class-toggle pe-cursor"
          style={{
            color: selectedTog == "class" && "#030712",
            backgroundColor: selectedTog == "class" && "#FFFFFF",
          }}
        >
          Class summary
        </div>
        <div
          onClick={() => setselectedTog("student")}
          className="class-toggle pe-cursor"
          style={{
            color: selectedTog == "student" && "#030712",
            backgroundColor: selectedTog == "student" && "#FFFFFF",
          }}
        >
          {" "}
          Student Details{" "}
        </div>
      </div>

      {selectedTog == "class" && <ExportClass />}
      {selectedTog == "student" && <ExportStudent />}




    </div>
  );
};

export default ReportExportUI;
